import { TabList as ChakraTabList, type TabListProps } from '@/ui';

// ahTabRail's own translucent bg is designed to sit on surface.panel; on the
// white popover we override it to surface.panel so the rail reads.
export const FilterTabList = (props: TabListProps) => (
  <ChakraTabList
    {...props}
    bg="surface.panel"
    borderBottom="none"
    // The panel below it is the part that gives when the card is height-capped.
    flexShrink={0}
    gap={1}
    layerStyle="ahTabRail"
    m={1}
    p={1}
  />
);
